import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { loaderStateTrue, loaderStateFalse, handleActiveLink } from '../../../../Actions/AllAction';
import ErrorBoundary from '../../../../Utility/Components/ErrorBoundary';
import '../../../../Utility/Public/css/common.scss';
import '../../../../Utility/Public/css/commonresponsive.scss';
import '../../../../Utility/Public/css/mt-modules-scoped.css';
import '../Assets/css/RevenueManagerDoc.scss'

// Import the external RevenueManager component
import { RevenueManager, configureRevenueManager, CurrencyProvider, AuthProvider } from '@mt/revenue-manager-module';
import '@mt/revenue-manager-module/dist/style.css';

class RevenueManagerPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isConfigured: false,
    };
  }

  componentDidMount() {
    try {
      this.props.handleActiveLink("revenue_module", "");

      // Configure the revenue manager with auth token and API base URL
      const token = this.props.token || localStorage.getItem('token');
      const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

      configureRevenueManager({
        apiBaseUrl: apiBaseUrl,
        authToken: token,
        mockMode: false, // Set to true for development/testing with mock data
      });

      this.setState({ isConfigured: true });
    } catch (error) {
      console.error('Error configuring Revenue Manager:', error);
    }
  }

  componentWillUnmount() {
    // Cleanup if needed
  }

  render() {
    const { isConfigured } = this.state;

    if (!isConfigured) {
      return (
        <div className="loading-container loading-container-revenue-manager">
          <p>Loading Revenue Manager...</p>
        </div>
      );
    } else {
      return (
        <ErrorBoundary>
          <div className='revenue-manager-page-container'>
            <div className="revenue-manager-page">
              <div className="mt-module-style-normalize">
                <AuthProvider authToken={this.props.token} businessDetails={this.props.businessDetails} config={{
                  apiBaseUrl: `${process.env.BASE_URL}${process.env.EXTENDED_URL}${this.props.userCredentials?.user_details?.version}`,
                }}>

                  <CurrencyProvider>
                    <RevenueManager />
                  </CurrencyProvider>
                </AuthProvider>
              </div>
            </div>
          </div>
        </ErrorBoundary>
      );
    }
  }
}

const mapStateToProps = (globalState) => {
  return {
    userCredentials: globalState.LoginReducer.userCredentials,
    token: globalState.LoginReducer.token,
    selectedLanguage: globalState.LoginReducer.selectedLanguage,
    businessDetails: globalState.LoginReducer.userEntryType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loaderStateTrue: () => dispatch(loaderStateTrue()),
    loaderStateFalse: () => dispatch(loaderStateFalse()),
    handleActiveLink: (type, name) => dispatch(handleActiveLink(type, name)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RevenueManagerPage));
